import { render, staticRenderFns } from "./ProductDetailSkuModule.vue?vue&type=template&id=7b5d2c37&scoped=true"
import script from "./ProductDetailSkuModule.vue?vue&type=script&lang=js"
export * from "./ProductDetailSkuModule.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailSkuModule.vue?vue&type=style&index=0&id=7b5d2c37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5d2c37",
  null
  
)

export default component.exports